import * as Yup from "yup";
import { Formik } from "formik";
import { toast } from "react-toastify";
import Card from "../../atoms/Card";
import InputField from "../../atoms/InputField";
import TemplateForm from "../../atoms/TemplateForm";
import { useSession } from "../../../context/SessionContext";
import { UPDATE_USER } from "../../../api/apiUsers";

const EditPerfilForm = () => {
    const { user } = useSession();

    const validationSchema = Yup.object({
        email: Yup.string().email("El email no es valido").required("El email es requerido"),
        name: Yup.string().required("El nombre es requerido"),
    });

    const handleSubmit = async (values, { setSubmitting }) => {
        try {
            const normalizedEmail = values.email.trim().toLowerCase();
            await UPDATE_USER(user.id, {...values, email:normalizedEmail});
            toast.success("Sesión iniciada correctamente");
        } catch (error) {
            toast.error("Error al iniciar sesión");
            console.error(error);
        } finally {
            setSubmitting(false);
        }
    };

    const initialValues = {
        name: user?.name || "",
        password: "",
        email: user?.email || "",
        cellphone: user?.cellphone || "",
    };

    return (
        <Card>
            <Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={validationSchema}>
                {({ isSubmitting }) => (
                    <TemplateForm
                        fields={
                            <>
                                <InputField name="name" label="Nombre" placeholder="Nombre de usuario" />
                                <InputField name="email" label="Correo electrónico" placeholder="Correo electrónico" />
                                <InputField name="password" type="password" label="Contraseña (opcional)" placeholder="Contraseña"/>
                                <InputField name="cellphone" type="number" label="Numero de contacto" placeholder="Número de teléfono"/>
                            </>
                        }
                        isSubmitting={isSubmitting}
                        textButton="Editar perfil"
                    />
                )}
            </Formik>
        </Card>
    );
};

export default EditPerfilForm;